export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/icon_need_help-9e1cff47f27341e8aa69dc7cecd5def7.svg";